import React, { useContext } from "react";
import { Context } from "../components/Context";

export default function Index() {
  const { listData } = useContext(Context);
  console.log(listData);
  return <></>;
}
